import http from '../../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/demo/bscClueOnlineMatrix',



    //线索管理查询
    selectById(id){
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            params: {id:id}
        })
    },


    //保存修改接口
    saveOrUpdate(query){
        return http({
            url: this.baseurl+'/saveOrUpdate',
            method: 'post',
            data: query
        });
    },


    //线索管理查询
    selectPage(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            data: query,
        })
    },

    //指派
    designate(query){
        return http({
            url: this.baseurl+'/designate',
            method: 'post',
            data: query
        });
    },

    //承接
    undertake(query){
        return http({
            url: this.baseurl+'/undertake',
            method: 'post',
            params: query
        });
    },

    //上传回款凭证
    uploadPaymentVoucher(query){
        return http({
            url: this.baseurl+'/uploadPaymentVoucher',
            method: 'post',
            data: query
        })
    },
    //二次确认
    secondaryConfirmation(query){
        return http({
            url: this.baseurl+'/secondaryConfirmation',
            method: 'post',
            params: query
        });
    },
    //保存回传物流信息
    saveWlInfo(query){
        return http({
            url: this.baseurl+'/saveWlInfo',
            method: 'post',
            data: query
        })
    },



    //查询线索日志
    selectCluePushLog(query){
        return http({
            url: '/api/swyl/bscCluePushLog/getCluePushLogByMainId',
            method: 'post',
            data: query
        })
    },


    // 获取型号
    selectAllwuliao(query){
        return http({
            url: this.baseurl+'/selectAllwuliao',
            method: 'post',
            data: query
        })
    },

    //获取托盘商联系人
    selectPalletDealer(code){
        return http({
            url: '/api/swyl/v1/demo/bscPalletDealer/selectByCode',
            method: 'post',
            params:  { companyCode: code }
        })
    },

    //获取战区列表
    selectWarZone(){
        return http({
            url:  this.baseurl+'/selectWarZone',
            method: 'post',
        })
    },


}
